import { Swiper, EffectFade, Autoplay, Pagination, A11y } from 'swiper/swiper.esm.js';
import {
    getImageSliderOptions,
    getImageSliderToggleLabel,
    reduceImageSliderState,
    shouldRunImageSliderAutoplay
} from '../utils/image-slider-runtime.js';

Swiper.use([EffectFade, Autoplay, Pagination, A11y]);

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.querySelectorAll('.js-image-slider').forEach((root) => {
    const slideCount = root.querySelectorAll('.swiper-slide').length;
    const pagination = root.querySelector('.js-image-slider-pagination');
    const options = getImageSliderOptions({ slideCount, reduceMotion });

    const swiper = new Swiper(root, {
        ...options,
        pagination: pagination ? { el: pagination, clickable: true } : false
    });

    const toggle = root.querySelector('.js-image-slider-toggle');
    if (!toggle) {
        return;
    }
    if (!options.autoplay) {
        toggle.hidden = true;
        return;
    }

    let state = { userPaused: false, hovering: false };

    const update = () => {
        toggle.setAttribute('aria-label', getImageSliderToggleLabel(state.userPaused));
        toggle.dataset.paused = String(state.userPaused);

        const shouldRun = shouldRunImageSliderAutoplay(state);
        if (shouldRun && !swiper.autoplay.running) {
            swiper.autoplay.start();
        } else if (!shouldRun && swiper.autoplay.running) {
            swiper.autoplay.stop();
        }
    };

    const dispatch = (action) => {
        state = reduceImageSliderState(state, action);
        update();
    };

    toggle.addEventListener('click', () => dispatch({ type: 'toggle' }));
    root.addEventListener('pointerenter', (event) => dispatch({ type: 'pointerenter', pointerType: event.pointerType }));
    root.addEventListener('pointerleave', (event) => dispatch({ type: 'pointerleave', pointerType: event.pointerType }));
    root.addEventListener('focusin', (event) => dispatch({ type: 'focusin', onToggle: event.target === toggle }));
    update();
});
